/**
 * Perguntas frequentes (reutilizadas na landing e na seção FAQ e Suporte do app).
 */

export const FAQ_ITEMS = [
  {
    question: 'Como coloco o RetornaAr no meu celular?',
    answer:
      'Você não precisa baixar na App Store nem na Play Store. Acesse o RetornaAr pelo navegador (de preferência Chrome no Android ou Safari no iPhone), entre na sua conta e adicione o site à tela inicial. Assim aparece um ícone como de aplicativo e o sistema abre em tela cheia, sem barra de endereço.\n\nNo Android (Chrome): abra o menu (três pontos) e escolha "Instalar app" ou "Adicionar à tela inicial" — o nome exato depende do aparelho e da versão do Chrome.\n\nNo iPhone (Safari): toque no botão Compartilhar e depois em "Adicionar à Tela de Início".\n\nSe o navegador oferecer "Instalar" ou "Adicionar à tela inicial" em outro lugar do menu, pode usar — o efeito é o mesmo: acesso rápido pelo ícone na home do celular.',
  },
  {
    question: 'O sistema envia mensagens para os meus clientes?',
    answer:
      'Não. O RetornaAr não envia nenhuma mensagem para os seus clientes. Ele envia o lembrete apenas para você — o dono da empresa. Você é quem decide como e quando entrar em contato com cada cliente. O controle da comunicação é sempre seu.',
  },
  {
    question: 'Como funciona o lembrete que eu recebo?',
    answer:
      'Quando a data de manutenção de um cliente se aproxima, você recebe uma mensagem no seu próprio WhatsApp com algo como: "Hora de entrar em contato com [Nome do Cliente] — manutenção do AC vence hoje." Aí é você quem liga, manda mensagem ou agenda do jeito que preferir.',
  },
  {
    question: 'É difícil de usar? Preciso de treinamento?',
    answer:
      'Não. O sistema foi feito para donos de empresa de AC, não para técnicos de informática. Você cadastra um serviço em menos de 1 minuto: nome do cliente, modelo do AC (opcional) e a periodicidade da manutenção. Se você sabe usar o WhatsApp, você sabe usar o RetornaAr.',
  },
  {
    question: 'Quais informações preciso cadastrar?',
    answer:
      'Apenas o nome do cliente e a periodicidade da manutenção (3, 6 ou 12 meses). O modelo do ar-condicionado é opcional. A data do serviço é preenchida automaticamente com o dia de hoje, mas você pode ajustar se o serviço foi feito em outra data.',
  },
  {
    question: 'O que acontece depois que eu recebo o lembrete?',
    answer:
      'Nada automático. O sistema apenas te avisa. Você decide o que fazer: ligar para o cliente, mandar uma mensagem no WhatsApp, ou agendar uma visita. O RetornaAr não age por conta própria — ele só garante que você não vai esquecer.',
  },
  {
    question: 'Quando o sistema vai estar disponível?',
    answer:
      'Estamos em fase piloto. As primeiras 10 empresas que se cadastrarem terão acesso gratuito ao sistema. Preencha o formulário acima e entraremos em contato pelo WhatsApp para liberar seu acesso.',
  },
  {
    question: 'Quanto vai custar depois do período gratuito?',
    answer:
      'Os preços ainda estão sendo definidos. Quem participar do piloto gratuito terá condições especiais quando o sistema for lançado oficialmente. Nosso objetivo é que o custo seja uma fração do que você vai recuperar em receita.',
  },
] as const;
